import React, {Component} from "react";
import {TableOrderButton} from "../../buttons/TableOrderButton";
import {ColumnWithOrdering} from "../ColumnWithOrdering";
import {SORT_DOWN, SORT_UP} from "../../../utils/Array.extensions";
import {ColumnTitle} from "./ColumnTitle";
import {ColumnHelper} from "./ColumnHelper";

export class ColumnHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            direction: this.props.defaultOrderingDirection || SORT_DOWN,
        };
        this.handleClick = this.handleClick.bind(this);
    }

    // event handlers

    handleClick(event) {
        event.preventDefault();
        if (!this.props.canBeSorted) {
            return;
        }

        let columnWithOrdering = new ColumnWithOrdering(this.props.columnId, this.state.direction);
        if (this.props.isActive) {
            const newDirection = this._toggleDirection();
            columnWithOrdering = new ColumnWithOrdering(this.props.columnId, newDirection);
        }
        this.props.onSetOrdering(columnWithOrdering);
    }

    // private

    _toggleDirection() {
        let newDirection;
        if (this.state.direction === SORT_DOWN) {
            newDirection = SORT_UP;
        } else if (this.state.direction === SORT_UP) {
            newDirection = SORT_DOWN;
        } else {
            throw new Error(`Invalid direction state ${this.state.direction}`);
        }
        this.setState({direction: newDirection});
        return newDirection;
    }

    // rendering

    renderSortingArrow() {
        if (this.props.canBeSorted) {
            return <TableOrderButton isActive={this.props.isActive}
                                     direction={this.state.direction}/>
        } else {
            return null;
        }
    }

    renderColumnHelper() {
        if (this.props.hasHelper) {
            return <ColumnHelper description={this.props.helper}/>
        } else {
            return null;
        }
    }

    defaultWidthStyle () {
        if(this.props.defaultWidth !== null)
            return {width:this.props.defaultWidth};
        return {};
    }


    render() {
        const baseClassName = this.props.canBeSorted ? "dashboard-column-header header-ordering" : "dashboard-column-header";
        const className = this.props.className ? `${baseClassName} ${this.props.className}` : baseClassName;
        return (
            <th className={className}
                onClick={this.handleClick}
                ref={this.props.thRef}  // Attach ref passed from the parent component
                data-column-id={this.props.columnId}
                style={this.props.style}              // ancho inline opcional (Portal: resize)
                draggable={this.props.draggable}      // reorder opcional (Portal); agency no lo pasa
                onDragStart={this.props.onDragStart}
                onDragOver={this.props.onDragOver}
                onDrop={this.props.onDrop}
                onDragEnd={this.props.onDragEnd}
                {...this.props.guideAnchor}           // ancla de las guías in-app (opcional)
            >
                <ColumnTitle title={this.props.title} subtitle={this.props.subtitle} additionalButton={this.props.additionalButton} />
                {this.renderSortingArrow()}
                {this.renderColumnHelper()}

                {/* Resize handle — draggable=false para que arrancar un resize no dispare el drag de reorder del th */}
                <div
                    className="resize-handle"
                    draggable={false}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => this.props.onInitResize(e, this.props.columnId)} // Trigger resize logic
                ></div>
            </th>
        )
    }
}